import Auth from '../modules/Authentication'
import { handleErrors, handleResponse } from '../modules/Utils'
import { apiUrl } from '../variables/index'

const headers = {}

export default class Entitlements {
  auth = new Auth()
  list = (owner) => {
    const select = [
      '_key',
      '_id',
      '_rev',
      'contract',
      'leaves',
      'owner',
      'status',
      'terminateDate',
      'name',
      'year',
      'active',
      'country',
      'married',
      'claims',
      'default',
      'fiscal',
      'date',
      'superman',
    ].toString()
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}entitlements?select=${select}` + (owner ? `&owner=${owner || ''}` : ''), {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
